import { BASE_PLAN_SUB_TYPES, BILLING_CYCLE, planTypes } from "@/common/constants";
import { flowTypes, pageConfig } from "@/common/service/page-config";
import { isEmptyVal } from '@/utils';

const PlanScope = {
  scopesTest: [
    plan => plan && (plan.billing_cycle === BILLING_CYCLE.MONTHLY && plan.category === BASE_PLAN_SUB_TYPES.PRO),
  ],
  isInScope(plan) {
    return this.scopesTest.findIndex(test => test(plan)) !== -1;
  }
};

const getters = {
    /**
     * relate to: https://zoomvideo.atlassian.net/browse/OBT-333
     * Calculate the percentage increase in quantity
     * 1. Just for pro monthly license change.
     * 2. Because the plan_code will change in the case of Pro Price Increase, we cannot use plan_code to determine whether it is a license change case.
     * 3. It will return -1 when license is decrease.
     */
    licenseIncreaseQty: (_, getters) => {

      if (!getters.currentEditPlan || !getters.currentEditPlan.cartInfo) return -1;
      const { billing_cycle: oldBillingCycle, category: oldCategory, cartInfo: { selected_number: oldQty } } = getters.currentEditPlan;

      const currentSelectedPlan = getters.getSelectedPlans[0];
      if (!currentSelectedPlan || !currentSelectedPlan.cartInfo) return -1;

      const { billing_cycle: newBillingCycle, category: newCategory, cartInfo: { selected_number: newQty } } = currentSelectedPlan;
      if (newBillingCycle !== oldBillingCycle || newCategory !== oldCategory) return -1;
      if (oldQty >= newQty) return -1;
      return ((newQty - oldQty) / oldQty) * 100;
    },
    isInScope: (_, getters) => PlanScope.isInScope(getters.currentEditPlan),
    /**
     * https://zoomvideo.atlassian.net/browse/OBT-333
     */
    isfraudRiskOperationEligible: (_, getters) => {
      const { p2pFraudRiskControlConfig = {} } = getters.basicConfig;
      const isEditFlow = pageConfig.type === flowTypes.edit
      const planIsInScope = PlanScope.isInScope(getters.currentEditPlan);
      const isCouponLink = !isEmptyVal(pageConfig.marketingCoupon) && getters.accountWithCouponDiscount;

      return (
        p2pFraudRiskControlConfig.hasPotentialP2PFraudRisk &&
        isEditFlow &&
        planIsInScope &&
        !isCouponLink
      )
    },
    isfraudRiskOperation: (_, getters) => {
      const { p2pFraudRiskControlConfig = {} } = getters.basicConfig;
      if (!getters.isfraudRiskOperationEligible) return false;
      return (getters.licenseIncreaseQty > (p2pFraudRiskControlConfig.licenseIncreaseThreshold || 900))
    },
    isSms2FaSupportedFlow: (_, getters) => {
      if (!getters.selectedAllPbxPlans || !getters.selectedAllPbxPlans.length) return false;
      const $context = window.$context;
      return ($context.is.buyNow || $context.is.basic2pro || $context.is.pro2bundle || $context.is.biz2bundle || $context.is.add2cart) && $context.type !== planTypes.ZONE_PRO_PLUS;
    },
};

export default { getters }
